"use client";

import * as React from "react";
import { useToast } from "@/hooks/use-toast";
import { Toast, ToastClose, ToastDescription, ToastProvider, ToastTitle, ToastViewport } from "@/components/ui/toast";

// Toast disattivati in tutta l'app: non renderizza nulla.
export function Toaster() {
  return null;
}
